<template>
  <div class="firstPage">
    <div class="top">
      <div class="top_item">
        <div id="searchECharts"></div>
        <div class="top_right">
          <span class="top_title">搜索最多：</span>
          <span class="top_text">{{ searchStr }}</span>
        </div>
      </div>
      <div class="top_item">
        <div id="oredrECharts"></div>
        <div class="top_right">
          <span class="top_title">下单最多：</span>
          <span class="top_text">{{ oredrStr }}</span>
        </div>
      </div>
      <div class="top_item">
        <div id="collectECharts"></div>
        <div class="top_right">
          <span class="top_title">收藏最多：</span>
          <span class="top_text">{{ collectStr }}</span>
        </div>
      </div>
    </div>
    <div class="cen">
      <div id="priceECharts"></div>
      <div class="cen_sel">
        <label class="label">日期范围：</label>
        <el-select
          v-model="priceDates"
          placeholder="请选择日期"
          @change="getPrice"
        >
          <el-option label="7天内" :value="7"></el-option>
          <el-option label="半个月内" :value="15"></el-option>
          <el-option label="一个月内" :value="30"></el-option>
          <el-option label="三个月内" :value="90"></el-option>
          <el-option label="半年内" :value="180"></el-option>
          <el-option label="一年内" :value="365"></el-option>
        </el-select>
      </div>
    </div>
  </div>
</template>

<script>
// 导入图标功能
import * as echarts from "echarts";

export default {
  name: "dataCount",
  data() {
    return {
      searchStr: "",
      oredrStr: "",
      collectStr: "",
      priceDates: 7,
      priceECharts: null,
    };
  },
  mounted() {
    this.getSearch();
    this.getOrder();
    this.getCollect();
    this.getPrice();
  },
  methods: {
    preOption(title, tips, data, color) {
      let name = data.map((item) => item.name);
      let value = data.map((item) => item.value);
      return {
        color: [color],
        title: {
          text: title,
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c}",
        },
        xAxis: {
          data: name,
        },
        yAxis: {
          axisLabel: {
            formatter: function (value) {
              if (value > 1000) {
                return value / 1000 + "k";
              }
              return value;
            },
          },
        },
        series: [
          {
            name: tips,
            type: "bar",
            data: value,
          },
        ],
      };
    },
    getSearch() {
      let data = {
        type: "GoodsSearch",
        startDate: "",
        endDate: "",
        strWhere: "",
        datetype: "0",
        PageIndex: 1,
        PageSize: 10,
      };
      let proc = "Proc_Admin_Statistical"; //存储过程名
      let type = "ReturnList";
      this.$requestSys({
        method: "post",
        url:
          "goods/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
      })
        .then((res) => {
          if (res.flag == 0) {
            let data = res.data.map((item) => ({
              name: item.SearchValue,
              value: item.Num,
            }));
            // this.searchStr = data[0].name;
            //查找最大值
            let max = 0;
            data.forEach((item) => {
              if (parseInt(item.value) > parseInt(max)) {
                max = item.value;
                this.searchStr = item.name;
              }
            });
            let searchECharts = echarts.init(
              document.getElementById("searchECharts")
            );
            searchECharts.setOption(
              this.preOption("商品搜索频率", "搜索热词", data, "#55D8FE")
            );
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    getOrder() {
      let data = {
        type: "Pc_ProductSaveOrder",
        startDate: "",
        endDate: "",
        strWhere: "",
        datetype: "0",
        PageIndex: 1,
        PageSize: 10,
      };
      let proc = "Proc_Admin_Statistical"; //存储过程名
      let type = "ReturnList";
      this.$requestSys({
        method: "post",
        url:
          "goods/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
      })
        .then((res) => {
          if (res.flag == 0) {
            let data = res.data.map((item) => ({
              name: item.sub_title,
              value: item.Num,
            }));
            // this.oredrStr = data[0].name;
            //查找最大值
            let max = 0;
            data.forEach((item) => {
              if (parseInt(item.value) > parseInt(max)) {
                max = item.value;
                this.oredrStr = item.name;
              }
            });
            let oredrECharts = echarts.init(
              document.getElementById("oredrECharts")
            );
            oredrECharts.setOption(
              this.preOption("下单频率统计", "下单商品", data, "#A3A0FB")
            );
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    getCollect() {
      let data = {
        type: "Pc_CollectionStatistical",
        startDate: "",
        endDate: "",
        strWhere: "",
        datetype: "0",
        PageIndex: 1,
        PageSize: 10,
      };
      let proc = "Proc_Admin_Statistical"; //存储过程名
      let type = "ReturnList";
      this.$requestSys({
        method: "post",
        url:
          "goods/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
      })
        .then((res) => {
          if (res.flag == 0) {
            let data = res.data.map((item) => ({
              name: item.sub_title,
              value: item.Num,
            }));
            // this.collectStr = data[0].name;
            //查找最大值
            let max = 0;
            data.forEach((item) => {
              if (parseInt(item.value) > parseInt(max)) {
                max = item.value;
                this.collectStr = item.name;
              }
            });
            let collectECharts = echarts.init(
              document.getElementById("collectECharts")
            );
            collectECharts.setOption(
              this.preOption("商品收藏统计", "收藏商品", data, "#5EE2A0")
            );
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    getPrice() {
      let data = {
        type: "GetDayOrderAmount",
        dates: this.priceDates,
      };
      let proc = "Proc_Admin_Statistical"; //存储过程名
      let type = "ReturnList";
      this.$requestSys({
        method: "post",
        url:
          "goods/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
      })
        .then((res) => {
          console.log(res);
          if (res.flag == 0) {
            // let data = this.changePriceRes(res.data, this.priceDates);
            let data = res.data.map((item) => {
              return {
                name: item.rq,
                value: item.amount,
              };
            });
            let priceECharts = this.priceECharts;
            if (!priceECharts) {
              priceECharts = echarts.init(
                document.getElementById("priceECharts")
              );
              this.priceECharts = priceECharts;
            }
            priceECharts.setOption({
              color: ["#A7A7FF", "#FFFFFF"],
              title: {
                text: "下单金额统计",
              },
              tooltip: {
                trigger: "item",
                formatter: "{a} <br/>{b} : {c}",
              },
              xAxis: {
                data: data.map((item) => item.name),
              },
              yAxis: {
                axisLabel: {
                  formatter: function (value) {
                    if (value > 1000) {
                      return value / 1000 + "k";
                    }
                    return value;
                  },
                },
              },
              series: [
                {
                  name: "每日金额",
                  type: "line",
                  data: data.map((item) => item.value),
                },
              ],
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    changePriceRes(list, dates) {
      let obj = {};
      let data = [];
      let date = new Date().getTime() - 1000 * 60 * 60 * 24 * (dates + 1);
      for (let i = 1; i <= dates; i++) {
        obj[this.$formatDate(date + i * 1000 * 60 * 60 * 24)] = "0";
      }
      for (let i = 0; i < list.length; i++) {
        obj[list[i].rq] = list[i].amount;
      }
      for (let key in obj) {
        data.push({
          name: key,
          value: obj[key],
        });
      }
      return data;
    },
  },
};
</script>

<style scoped>
.firstPage {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 20px;
  background-color: #ebf1f3;
}
.top {
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 240px;
}
.top_item {
  box-sizing: border-box;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 32%;
  height: 100%;
  padding: 10px;
  background-color: #fff;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.04);
}
.top_right {
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-content: center;
  flex-wrap: wrap;
  width: 100%;
  height: 40px;
}
.top_title {
  display: inline-block;
  height: 40px;
  font-size: 16px;
  color: #43425d;
  line-height: 40px;
  text-align: center;
}
.top_text {
  display: inline-block;
  height: 40px;
  font-size: 16px;
  color: #43425d;
  line-height: 40px;
  text-align: center;
}
#searchECharts {
  width: 100%;
  height: 100%;
}
#oredrECharts {
  width: 100%;
  height: 100%;
}
#collectECharts {
  width: 100%;
  height: 100%;
}
.cen {
  position: relative;
  width: 100%;
  height: 300px;
  margin-top: 10px;
}
#priceECharts {
  width: 100%;
  height: 100%;
}
.cen_sel {
  position: absolute;
  top: 0px;
  right: 30px;
  z-index: 1;
}
</style>